import { createSlice } from "@reduxjs/toolkit";

export const dataRemotoSlice = createSlice({
  name: "dataRemoto",
  initialState: {
    dataRemoto: false,
  },
  reducers: {
    dataRemotoAdd: (state, action) => {
      state.dataRemoto = action.payload;
    },
  },
});

export const { dataRemotoAdd } = dataRemotoSlice.actions;
export default dataRemotoSlice.reducer;